import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DialogRef } from '@angular/cdk/dialog';

export enum PerioExamNewExamConfirmationEnum {
  New,
  Resume,
}

@Component({
  selector: 'lib-perio-new-exam-confirmation-modal',
  imports: [TranslatePipe],
  templateUrl: './perio-new-exam-confirmation-modal.component.html',
  styleUrl: './perio-new-exam-confirmation-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PerioNewExamConfirmationModalComponent {
  private readonly dialogRef = inject(DialogRef<PerioExamNewExamConfirmationEnum>);

  protected onStartNewClick(): void {
    this.dialogRef.close(PerioExamNewExamConfirmationEnum.New);
  }

  protected onResumeClick(): void {
    this.dialogRef.close(PerioExamNewExamConfirmationEnum.Resume);
  }
}
